import React from 'react'
import styled from '@emotion/styled'
import { math } from 'polished'
import { space as styledSpace } from 'styled-system'
import { NUMBER_SIZE, OFFSET } from './Step'

const SHIFT = math(`${NUMBER_SIZE} + ${OFFSET}`)

const OrderedList = styled('ol')`
  list-style: none;
  counter-reset: steps;

  position: relative;
  left: -${SHIFT};

  width: calc(100% + ${SHIFT});
  padding-left: ${SHIFT};

  ${styledSpace}
`

interface IStepperProps {
  children: React.ReactNode
}

const Stepper = ({ children, ...props }: IStepperProps) => (
  <OrderedList {...props}>{children}</OrderedList>
)

export default Stepper
